import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    storeEmployeeAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/store`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    searchEmployeeAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/search`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteEmployee(Context, employeeId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/employees/delete/${employeeId}`)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateEmployeeAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/employees/update`, payload)
          .then((res) => {
            resolve(res.data.employee);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findCountEmployee() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/employees/find-count`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findEmployeesAction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/employees/find-employees`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    vinculeEmployeeVehicule(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/vincule-vehicule`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    vinculeEmployeeTool(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/vincule-tool`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    totalSalaryAction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/employees/total-salary`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findEmployessByLocation() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/employees/find-by-location`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findEmployessCategoriesAction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/employees/find-categories`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    countByCategory() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/employees/count-by-category`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findResponsiblesAction(Context, locationId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/employees/find-by-location/${locationId}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },


    findEmployessNoPayRollAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/find-employees-no-payroll/`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findLiderAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/find-lider`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    
    findEmployessAllByArg(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/find-employees-all`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findEmployeesByPercentegesAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/employees/find-employees-by-percentege`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
